<template>
  <div class=" fill-height d-flex flex-column">
    <div class="headerArea text-center re">
      <img src="../../assets/logo/roobroo-logo.png" style="margin: 0px auto" width="160" alt="روب‌رو">
    </div>
    <div class="paymentContext flex-grow-1" :class="this.classes">
      <div v-if="$route.query.status == 'paid'">
        <div class="text-center" id="ga_purchase_successful">
          <lottie-animation
              ref="anim"
              :animationData="require('../../assets/animation/PaymentSuccess.json')"
              :loop="false"
              :autoPlay="true"
              style="margin: 0px auto"
              :style="$vuetify.breakpoint.mdAndUp ? 'width: 280px' :'width:150px'"
          />
          <div class="titlePage">
            پرداخت شما با موفقیت انجام شد
          </div>

          <div class="itemBox" style="margin-top: 60px" v-if="session_joruney">
            <div class="doctorHeaderArea d-flex">
              <div class="imageDoctor">
                <img :src="session_joruney.doctor.user.avatar" alt="">
              </div>
              <div class="d-flex flex-column justify-center mr-2">
                <div class="doctorName">
                  دکتر
                  {{ session_joruney.doctor.user.full_name }}
                </div>
                <div class="doctorSubTitle">
                  {{ session_joruney.doctor.subtitle }}
                </div>
              </div>
            </div>
            <div class="line"></div>
            <div class="sessionDetail">
              <div class="detailBox d-flex justify-space-between" v-if="$vuetify.breakpoint.mdAndUp">

                <div class="detailItem flex-column">
                  <div class="d-flex">
                    <div class="iconDetail d-flex flex-column justify-center">
                      <img src="../../assets/image/user-journey/calendar.svg" alt="">
                    </div>
                    <div class="nameDetail mx-1 d-flex flex-column justify-center">
                      تاریخ جلسه:
                    </div>
                  </div>
                  <div class="valueDetail">
                    {{ session_joruney.date_time.from_time | jalaliDateTime }}

                  </div>

                </div>
                <div class="detailItem flex-column">
                  <div class="d-flex">
                    <div class="iconDetail d-flex flex-column justify-center">
                      <img src="../../assets/image/user-journey/clock.svg" alt="">
                    </div>
                    <div class="nameDetail mx-1 d-flex flex-column justify-center">
                      ساعت جلسه:
                    </div>
                  </div>
                  <div class="valueDetail">
                    {{ session_joruney.date_time | getDayPeriodsLabel }}
                  </div>
                </div>
              </div>
              <div class="detailBox d-flex justify-space-between" v-else>
                <div class="detailItem  flex-column">
                  <div class="detailItem ">
                    <div class="iconDetail d-flex flex-column justify-center">
                      <img src="../../assets/image/user-journey/calendar.svg" alt="">
                    </div>
                    <div class="nameDetail mx-1 d-flex flex-column justify-center">
                      تاریخ جلسه:
                    </div>
                    <div class="valueDetail">
                      {{ session_joruney.date_time.from_time | jalaliDateTime }}
                    </div>
                  </div>
                  <div class="detailItem">
                    <div class="iconDetail d-flex flex-column justify-center">
                      <img src="../../assets/image/user-journey/clock.svg" alt="">
                    </div>
                    <div class="nameDetail mx-1 d-flex flex-column justify-center">
                      ساعت جلسه:
                    </div>
                    <div class="valueDetail">
                      {{ session_joruney.date_time | getDayPeriodsLabel }}

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="itemBox" style="margin-top: 16px;padding: 0px">
            <div class="factorDetail">
              <div class="factorItem mb-1">
                <div class="titleFactorItem">
                  شماره سفارش
                </div>
                <div class="contentFactorItem">
                  {{ cart.id }}
                </div>
              </div>
              <div class="line"></div>
              <div class="factorItem" style="margin-top: 16px" v-for="(item , i) in order.order.products" :key="i">
                <div class="titleFactorItem">
                  {{ item.title }}
                </div>
                <div class="contentFactorItem enContentFactorItem" style="font-family: Roboto !important;">
                   <span class="" style="margin-right: 7px">
                  {{ priceFilter(item.pivot.price) }}
                </span>
                  <span>
                  <template v-if="order.currency == 'rial'">
                    تومان
                  </template>
                    <template v-else>
                      $
                    </template>
                </span>

                </div>
              </div>
              <div v-if="session_joruney && isUserJourneyPackage">
                <div class="factorItem" style="margin-top: 16px">
                  <div class="titleFactorItem">
                    تخفیف
                  </div>
                  <div class="contentFactorItem enContentFactorItem"
                       style="font-family: Roboto !important;color: #FF6E6E">
                   <span class="" style="margin-right: 7px">
                     59.95
                </span>
                    <span>
                  <template v-if="order.currency == 'rial'">
                    تومان
                  </template>
                    <template v-else>
                      $
                    </template>
                </span>

                  </div>
                </div>
                <div class="factorItem" style="margin-top: 16px">
                  <div class="titleFactorItem">
                    مبلغ قابل پرداخت
                  </div>
                  <div class="contentFactorItem enContentFactorItem" style="font-family: Roboto !important">
                   <span class="" style="margin-right: 7px">
                     {{ priceFilter(order.payment.paid_amount) }}
                </span>
                    <span>
                  <template v-if="order.currency == 'rial'">
                    تومان
                  </template>
                    <template v-else>
                      $
                    </template>
                </span>

                  </div>
                </div>
              </div>

            </div>
            <div class="finalPayment">
              <div class="titleFactorItem" style="color: #30A778">
                پرداخت شده
              </div>
              <div>
                <div class="contentFactorItem enContentFactorItem" style="color: #30A778">
                   <span class="" style="margin-right: 7px">
                  {{ priceFilter(order.payment.paid_amount) }}
                </span>
                  <span>
                  <template v-if="order.currency == 'rial'">
                    تومان
                  </template>
                    <template v-else>
                      $
                    </template>
                </span>
                </div>
              </div>
            </div>
          </div>
          <v-btn class="submitBtn" :to="{name:'dashboard',params:{lang:'fa'}}" elevation="0">
            <template v-if="session_joruney">
              مشاهده نوبت رزرو شده
            </template>
            <template v-else>
              رفتن به پنل کاربری
            </template>
          </v-btn>
          <div class="mb-15"></div>
        </div>
      </div>
      <div v-else id="ga_purchase_failed">
        <lottie-animation
            ref="anim"
            :animationData="require('../../assets/animation/PaymentFailed.json')"
            :loop="false"
            :autoPlay="true"
            style="margin: 0px auto"
            :style="$vuetify.breakpoint.mdAndUp ? 'width: 280px' :'width:150px'"
        />
        <div class="titlePage" style="color:#FF5252;">
          متاسفیم، پرداخت شما ناموفق بود!
        </div>
        <div class="text-center mt-2" style="color:#616161;">
          {{ paymentFailureMessage }}
        </div>
        <div class="itemBox" style="margin-top: 16px;padding: 0px">
          <div class="factorDetail">
            <div class="factorItem mb-1">
              <div class="titleFactorItem">
                شماره سفارش
              </div>
              <div class="contentFactorItem">
                {{ cart && cart.id ? cart.id : '-' }}
              </div>
            </div>
            <div v-if="order && order.payment">
              <div class="factorItem" style="margin-top: 16px">
                <div class="titleFactorItem">
                  مبلغ قابل پرداخت
                </div>
                <div class="contentFactorItem enContentFactorItem" style="font-family: Roboto !important">
                   <span class="" style="margin-right: 7px">
                     {{ priceFilter(order.payment.paid_amount) }}
                </span>
                  <span>
                    <template v-if="order.currency == 'rial'">
                    تومان
                  </template>
                    <template v-else>
                      $
                    </template>
                </span>

                </div>
              </div>
            </div>

          </div>
        </div>
        <v-row>
          <v-col cols="6">
            <v-btn class="submitBtn" @click="rePay" elevation="0">
              پرداخت مجدد
            </v-btn>
          </v-col>
          <v-col col="6">
            <v-btn class="outLineSubmitBtn" outlined :to="{name:'dashboard',params:{lang:'fa'}}" elevation="0">
              رفتن به پنل کاربری
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="footerArea" v-if="$vuetify.breakpoint.mdAndUp">
      <div class="text-center flex-grow-1">
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
// import Vue from 'vue';
// import Tracker from '../../tracker';

import afterPaymentMixins from "@/mixins/afterPaymentMixins";
import {mapGetters} from "vuex";
import LottieAnimation from "lottie-web-vue";
import momentJalali from "moment-jalaali";
import EventsMixins from "@/mixins/EventsMixins";

export default {

  components: {LottieAnimation},
  mixins: [afterPaymentMixins, EventsMixins],
  computed: {
    ...mapGetters({
      'AppUrl': 'getAppUrl',
      'profile': 'getProfile'
    }),
    suggestedDays() {
      return this.days;
    },
    getLang() {
      return localStorage.getItem('local') || "fa"
    },
    successTitle() {
      if (this.getLang == 'fa') {
        return "پرداخت موفق"
      }
      return "Payment Was Successful"
    },
    action() {
      if (this.getLang == 'fa') {
        return " تایید"
      }
      return "confirm"
    },
    codeTrackingCode() {
      if (this.getLang == 'fa') {
        return "  شماره پیگیری"
      }
      return "Tracking Code"
    },
    failedTitle() {
      if (this.getLang == 'fa') {
        return "پرداخت با شکست مواجه شد"
      }
      return "Payment failed"
    },
    paymentFailureMessage() {
      return this.$route.query.message || this.$route.query.errorMessage || "پارامتر پرداخت نامعتبر است"
    }
  },
  mounted() {
    this.requesting('auth', 'getProfile').then(() => {
      this.profile = this.$store.getters.getUserInfo;
      this.processPayment()
      if (this.$route.query.status == 'paid' && this.$route.query.hasOwnProperty('successful_payment')) {
        this.checkSuccessPayment();
      }
    })
    this.requesting('auth', 'platformInfo')
  },
  watch: {
    paymentDialog(newVal) {
      if (!newVal) {
        this.redirectToStepper();
      }
    }
  },
  methods: {
    priceFilter(amount) {
      if (this.order.currency == 'rial') {
        return Number(amount).toLocaleString()
      } else {
        return amount
      }
    },
    rePay() {
      this.$emitEvent('setLoading', true)
      this.requesting('factor', 'payFactor', {
        factorID: this.cart.id
      }).then((resp) => {
        if (resp.data.state == 'SUCCESS') {
          window.location = resp.data.url
        }
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    toDashboard() {

      if (this.isNewCoustomer) {
        window.location.href = `${this.AppUrl}/fa/onboarding-new`
      } else {
        window.location.href = `${this.AppUrl}/fa/portal/home`
      }
    },
    toFactor() {
      this.$router.push(`/${this.$vuetify.rtl ? 'fa' : 'en'}/portal/home`)
    },
    processPayment() {
      if (this.$route.query.status == "paid") {
        // this.transactionClass = 'success';
        this.transactionClass = 'green--text';
        this.message = this.successTitle;
        this.btn_id = 'ga_purchase_successful';
      } else {
        this.btn_id = 'ga_purchase_failed';
        this.transactionClass = 'red--text';
        this.transactionRefId = null;
        this.message = this.failedTitle;
        this.validOrder = false;
      }
      this.paymentDialog = true
      this.transactionRefId = this.$route.query.ref_id || null;
      this.successfulPayment.trCode = this.$route.query.trCode || null;
    },

    // sendAgain() {
    //     this.$gtm.trackEvent(this.paydata);
    // },
    getCookie: function (cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    redirectToStepper() {
      // this.$router.push({path: this.getLang+'/panel/dashboard'});
      return;
    },
    callFirstPurchaseTrk(paymentId) {
      this.SendEventTrk({
        event_id: 'first_purchase_' + paymentId,
        name: 'first_purchase',
        email: this.profile.email,
        first_name: this.profile.firstname,
        last_name: this.profile.lastname,
        payload: {
          payment_id: paymentId,
        }
      })
    },
    checkSuccessPayment() {
      if (this.$route.query.hasOwnProperty('successful_payment')) {
        const paymentId = this.$route.query.successful_payment
        this.$emitEvent('setLoading', true)
        this.requesting('payment', 'getPaymentInfo', {
          paymentID: paymentId
        }).then((resp) => {
          this.isNewCoustomer = resp.data.newCustomer

          // validatePurchase flips event_fired on the first call, so a page
          // refresh returns true and must not re-send the purchase events.
          if (!resp.data.event_fired) {
            if (this.isNewCoustomer) {
              this.callFirstPurchaseTrk(paymentId)
            }

            this.SendEventTrk({
              event_id: 'purchase_' + paymentId,
              name: 'purchase',
              email: this.profile.email,
              first_name: this.profile.firstname,
              last_name: this.profile.lastname,
              payload: {
                payment_id: paymentId,
              }
            })
          }

          this.transactionCurrency = resp.data.currency
          this.prepareDataForWebengageAndSend(resp)
          console.log(this.classes, '12121')
          this.session_joruney = resp.data.cart.set_session_journey
          this.cart = resp.data.cart
          this.order = resp.data
          this.isUserJourneyPackage = this.order.order.products[0].id == 197
        }).catch(err => {
          // console.log(err)
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      }
    },
  },
  filters: {
    jalaliDateTime(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;

      return m.locale('fa').format('dddd,  jYYYY/jMM/jDD ');
    },
    getDayPeriodsLabel(time) {
      console.log(time.from_time)
      const hour = parseInt(momentJalali(time.from_time).format('HH'));
      const formated_time = momentJalali(time.from_time).format('hh:mm');
      if (hour) {
        if (hour >= 0 && hour < 12) {
          return formated_time + 'صبح'
        } else if (hour >= 12 && hour < 18) {
          return formated_time + 'عصر'
        } else if (hour >= 18 && hour <= 23) {
          return formated_time + 'شب'
        }
      }
    },

  },
  data() {
    return {
      transactionCurrency: null,
      isNewCoustomer: null,
      session_joruney: null,
      cart: null,
      order: null,
      isUserJourneyPackage: false,
    }
  }
}
</script>

<style>
@media (min-width: 200px) and (max-width: 800px) {
  .paymentContext {
    width: 90% !important;
    margin-top: 40px !important;
  }

  .imageDoctor img {
    width: 85px !important;
    height: 85px !important;
  }

  .doctorName {
    font-size: 20px !important;
  }

  .doctorSubTitle {
    font-size: 16px !important;
  }

  .titleFactorItem {
    font-size: 16px !important;

  }

  .contentFactorItem {
    font-size: 16px !important;

  }
}

.doctorHeaderArea {
}

.paymentContext {
  width: 34%;
  margin: 0px auto;
}

.factorItem {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
}

.finalPayment {
  border-radius: 0 0 8px 8px;
  background: rgba(215, 244, 233, 0.50);
  padding: 24px;
  display: flex;
  justify-content: space-between;
}

.titleFactorItem {
  color: #212121;
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.contentFactorItem {
  color: #212121;
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.enContentFactorItem * {
  font-family: YekanBakh, Roboto !important;
}

.imageDoctor img {
  width: 120px;
  height: 120px;
}

.sessionDetail {
  margin-top: 24px;
}

.doctorName {
  color: #212121;
  text-align: right;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 8px;
}

.line {
  height: 1px;
  background: #EEE;
}

.doctorSubTitle {
  color: #616161;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.titlePage {
  color: #30A778;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: -20px;
}

.itemBox {
  border-radius: 8px;
  border: 1px solid #EAF0F6;
  background: #FFF;
  padding: 24px;
}

.headerArea {
  background: white;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  height: 88px;
  display: flex;
  flex-direction: column;
  padding: 0px 85px;
  justify-content: center;
}

.factorDetail {
  padding: 24px 24px 16px 24px;
}

.submitBtn {
  border-radius: 8px;
  background: #39C990 !important;
  width: 100%;
  height: 48px !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
  color: white !important;
}

.outLineSubmitBtn {
  display: flex;
  width: 100%;
  height: 48px !important;
  padding: 0 19.55px;
  margin-top: 20px;
  justify-content: center;

  border-radius: 8px;
  border: 1px solid #39C990;
  align-items: center;
  color: #39C990 !important;

  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

.footerArea {
  border-top: 1px solid #EAF0F6;
  background: #FFF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}

</style>
